import { useEffect } from "react";
import { Form } from "antd";

const useConditionalValidation = (name, shouldValidateFields) => {
  if (!shouldValidateFields) return;

  const form = Form.useFormInstance();
  const field = Form.useWatch(name, form);

  useEffect(() => {
    // Only re-validate this field, not the whole form: this hook fires on every keystroke/change
    // of `field` (via useWatch), and it's shared by every conditional form-item across all EE
    // vendor templates (CheckboxItem, RadioItem, SelectItem, GenericFacilityItem,
    // GenericPhysicianItem, CaregiverRadioItem, CustomSelect). Calling validateFields() with no
    // args re-validates every field on the form on each of those changes, which would surface
    // (or re-surface) error UI on unrelated, untouched fields while the user is still filling the
    // form out. Scoping to [name] keeps re-validation limited to the field that actually changed.
    //
    // validateFields normally rejects with { values, errorFields, outOfDate } when the field
    // simply fails its rules - that's expected and already surfaced via the form's own error
    // UI, so it's not worth logging. Anything else (e.g. a validator throwing) is unexpected
    // and was previously swallowed silently - log it instead, matching the pattern in
    // FormItemWithWarning.
    form.validateFields([name]).catch((error) => {
      if (!error || !("errorFields" in error)) {
        console.error("useConditionalValidation error:", error);
      }
    });
  }, [field, form, name]);
};

export default useConditionalValidation;
